import { AgeRange } from '@/Types/gql/graphql';

export const LANGUAGE = [
  {
    label: 'English',
    value: 'ENGLISH',
  },
  {
    label: 'Spanish',
    value: 'SPANISH',
  },
  {
    label: 'French',
    value: 'FRENCH',
  },
  {
    label: 'German',
    value: 'GERMAN',
  },
  {
    label: 'Italian',
    value: 'ITALIAN',
  },
  {
    label: 'Chinese(Mandarin)',
    value: 'CHINESE(Mandarin)',
  },
  {
    label: 'Japanese',
    value: 'JAPANESE',
  },
  {
    label: 'Hindi',
    value: 'HINDI',
  },
  {
    label: 'Portuguese',
    value: 'PORTUGUESE',
  },
  {
    label: 'Arabic',
    value: 'ARABIC',
  },
];

export const PRIMARY_GOAL = [
  'Weight Loss',
  'Muscle Gain',
  'Improved Endurance',
  'Increased Flexibility',
  'General Fitness',
  'Other',
];

export const EQUIPMENT_AT_HOME = [
  'No Equipment',
  'Dumbbells',
  'Resistance Bands',
  'Kettlebells',
  'Barbell',
  'Exercise Mat',
  'Jump Rope',
  'Other',
];

export const WORKOUT_FREEQUENCY = [
  'Every day',
  'Only on weekends',
  'Occasionally / When I have time',
  'Once per week',
  'Twice per week',
  '3 times per week',
  '4 times per week',
];

export const AGE_RANGE_VALUE = {
  [AgeRange.Age_13_17]: '13-17 years',
  [AgeRange.Age_18_24]: '18-24 years',
  [AgeRange.Age_25_34]: '25-34 years',
  [AgeRange.Age_35_44]: '35-44 years',
  [AgeRange.Age_45_54]: '45-54 years',
  [AgeRange.Age_55Plus]: '55+ years',
};
